import { View, ScrollView, ViewStyle } from 'react-native';
import { useStore } from 'src/contexts/StoreContext';
import { ICON_NAMES } from '../icon/icon.helper';
import TextLato from '../text/text-lato/TextLato';
import { style } from './BottomSheetPrivacyPolicy.style';
import { CircularButton } from '../buttons/circular-button/CircularButton';
import { CIRCULAR_BUTTON_SIZES, CIRCULAR_BUTTON_TYPES } from '../buttons/circular-button/CircularButton.constants';
import { configurationTestID } from 'src/helpers/testIDs.helper';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { TestIDs } from 'src/constants/testIDs.constants';
import { BottomSheetScrollView } from '@gorhom/bottom-sheet';
import PolicyPrivacyContent from '../policy-privacy-content/PolicyPrivacyContent';

export const BottomSheetPrivacyPolicy = ({ bsStyle }: { bsStyle: ViewStyle }) => {
  const {
    i18n,
    bottomSheet: { closeBottomSheet },
  } = useStore();

  return (
    <BottomSheetScrollView contentContainerStyle={bsStyle}>
      <View style={style.container}>
        <CircularButton
          onPress={async () => closeBottomSheet()}
          accessible={true}
          accessibilityLabel={i18n.t('actions:close_x', { x: i18n.t('modal-privacy-policy:privacy-policy') })}
          accessibilityRole="button"
          iconName={ICON_NAMES.Close}
          style={style.icon}
          iconStyle={style.closeIcon}
          size={CIRCULAR_BUTTON_SIZES.SMALL}
          type={CIRCULAR_BUTTON_TYPES.ONLY_ICON}
          testID={configurationTestID(TestIDs.PRIVACY_POLICY, TestIDs.CLOSE)}
          focusId={configurationTestID(TestIDs.PRIVACY_POLICY, TestIDs.CLOSE)}
          focusOrder={0}
          focusGroup={FocusGroups.BOTTOM_SHEET}
        />

        <TextLato style={style.title}>{i18n.t('modal-privacy-policy:editor-privacy-policy-info')}</TextLato>
        <ScrollView style={style.contentWrapper}>
          <PolicyPrivacyContent />
        </ScrollView>
      </View>
    </BottomSheetScrollView>
  );
};
